import type { ShoppingItem } from '../types'
import { mergeShoppingItems } from './shopping'

const STORAGE_KEY = 'carnet-de-recettes.shopping-list'

export const loadShoppingList = (): ShoppingItem[] => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY)
    if (!value) return []

    const parsed: unknown = JSON.parse(value)
    if (!Array.isArray(parsed)) return []

    const validItems = parsed
      .filter((item): item is ShoppingItem => {
        if (!item || typeof item !== 'object') return false
        const candidate = item as Partial<ShoppingItem>
        return (
          typeof candidate.id === 'string' &&
          typeof candidate.key === 'string' &&
          typeof candidate.label === 'string'
        )
      })
      .map((item) => ({
        ...item,
        id: `${item.key.split('|')[0]}-${item.unit || 'sans-unite'}`,
        checked: Boolean(item.checked),
        sources: Array.isArray(item.sources)
          ? item.sources.filter((source): source is string => typeof source === 'string')
          : [],
      }))

    // Older versions could leave several entries for the same ingredient in localStorage.
    // Reusing the normal merge path also preserves compatible units and source names.
    return mergeShoppingItems([], validItems)
  } catch {
    return []
  }
}

export const saveShoppingList = (items: ShoppingItem[]): void => {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
}
